/* Bilingual strings. 繁體中文 is the primary locale — this is a Hong Kong
   project and the people whose histories it holds read Chinese first.
   English exists so the work travels.

   Adding a language: add a key block below, add it to LOCALES, done. The DOM is
   translated by attribute (data-i18n / data-i18n-placeholder) so no template
   changes are needed. */

export const LOCALES = ['zh', 'en']

const STRINGS = {
  zh: {
    tagline: '記錄填海如何改變香港的海岸線，以及水上人家的去向。',
    about: '關於',
    layers: '圖層',
    layer_stories: '故事',
    layer_relocation: '遷徙路線',
    layer_ecology: '生態記憶',
    layer_place: '消失的地方',
    basemap: '底圖',
    basemap_hint: '航空照片可直接看到填海造出的土地與海堤。',
    coastline: '歷史海岸線',
    coastline_hint: '選擇年代，比對填海前後的海岸。',
    coastline_opacity: '透明度',
    coastline_swipe: '左右對比',
    communities: '族群',
    search: '搜尋',
    search_placeholder: '地名、船名、人名⋯',
    timeline_label: '年代',
    reset: '重設',
    add_story: '記錄故事',
    export: '匯出資料',

    // Communities
    c_tanka: '蜑家',
    c_sheungan: '水上人',
    c_hoklo: '鶴佬 / 學佬',
    c_hakka: '客家',
    c_punti: '陸上 / 本地',
    c_other: '其他',

    // Kinds
    k_story: '故事',
    k_relocation: '遷徙',
    k_ecology: '生態',
    k_place: '地方',

    // Detail panel
    narrator: '講述者',
    recorded_by: '記錄者',
    period: '年代',
    community: '族群',
    moved_from: '由',
    moved_to: '遷至',
    distance: '距離',
    species_label: '魚類 / 物種',
    ecology_change_label: '環境變化',
    source: '來源',
    transcript: '訪談謄本',
    listen: '收聽錄音',
    report: '回報問題',
    share: '複製連結',
    link_copied: '連結已複製',
    withheld_note: '講述者要求不公開確切位置，此標記為約略範圍。',
    no_results: '此條件下沒有記錄。試試放寬年代或族群篩選。',

    // Submission form
    form_title: '記錄一個故事',
    form_lede: '每一段記憶都會即時出現在地圖上。請只分享你有權分享的內容 —— 若故事屬於別人，請先徵得對方同意。',
    f_kind: '這是哪一種記錄？',
    f_kind_story: '一個地方的記憶',
    f_kind_relocation: '一次遷徙（由海上到陸上）',
    f_kind_ecology: '漁場、魚類或海洋環境的變化',
    f_kind_place: '一個已經消失的地方',
    f_title_zh: '標題（中文）',
    f_title_en: '標題（English）',
    f_narrative_zh: '故事內容（中文）',
    f_narrative_en: '故事內容（English）',
    f_narrative_help: '中英文任填其一即可。可以是一段口述謄本，也可以是幾句記述。',
    f_where: '地點',
    f_pick_origin: '在地圖上點選位置',
    f_pick_dest: '點選遷入地點',
    f_place_name: '地方名稱',
    f_dest_place_name: '遷入地點名稱',
    f_no_point: '尚未選擇位置',
    f_precision: '位置準確度',
    p_exact: '準確',
    p_approximate: '大約',
    p_area: '一帶範圍',
    p_withheld: '不公開確切位置',
    f_precision_help: '選「不公開」時，地圖只會顯示約一公里範圍內的大概位置。',
    f_when: '年代',
    f_year_start: '由（年）',
    f_year_end: '至（年）',
    f_year_help: '不確定也沒關係，可只填其中一項，或留空。',
    f_communities: '相關族群',
    f_species: '魚類 / 物種',
    f_species_help: '用你慣用的叫法就可以，以逗號分隔。',
    f_ecology_change: '環境有什麼變化？',
    f_media: '錄音與相片',
    f_audio: '錄音檔（最大 50MB）',
    f_photos: '相片',
    f_transcript_zh: '謄本（中文）',
    f_transcript_en: '謄本（English）',
    f_provenance: '來源',
    f_narrator: '講述者稱謂',
    f_narrator_help: '可用化名或「匿名」。除非對方明確同意，請不要填寫全名。',
    f_birth_year: '出生年份',
    f_contributor: '記錄者姓名',
    f_contact: '聯絡電郵',
    f_contact_help: '不會公開，只用於研究團隊在有需要時與你聯絡。',
    f_source_note: '資料來源說明',
    f_source_help: '例如：2026年3月訪談、家族相簿、《香港漁民史》頁102。',
    consent_title: '同意聲明',
    consent_1: '我確認我有權分享這段內容。若內容來自他人的口述，我已取得對方同意公開。',
    consent_2: '我同意以 CC BY-SA 4.0 授權公開這段內容，供他人在註明出處的前提下使用。',
    submit: '發佈到地圖',
    submitting: '發佈中⋯',
    cancel: '取消',
    submit_ok: '已發佈，多謝你的記錄。',
    err_title: '請至少填寫一個標題。',
    err_point: '請在地圖上選擇位置。',
    err_dest: '遷徙記錄需要選擇遷入地點。',
    err_consent: '請勾選兩項同意聲明。',
    err_network: '發佈失敗，請稍後再試。',
    err_rate: '短時間內提交太多次，請稍等幾分鐘。',
    click_map_origin: '在地圖上點選故事發生的位置',
    click_map_dest: '在地圖上點選遷入的位置',

    // Report
    report_title: '回報問題',
    report_lede: '這個項目採用即時公開發佈。你的回報會交由研究團隊處理；涉及私隱或同意的個案會立即隱藏。',
    r_spam: '垃圾內容',
    r_abuse: '仇恨或攻擊性內容',
    r_privacy: '侵犯私隱',
    r_consent: '未經同意公開',
    r_inaccurate: '資料有誤',
    r_other: '其他',
    r_detail: '補充說明',
    report_send: '提交回報',
    report_ok: '已收到，多謝。',
  },

  en: {
    tagline: 'Mapping how reclamation redrew Hong Kong’s coastline — and where the boat people went.',
    about: 'About',
    layers: 'Layers',
    layer_stories: 'Stories',
    layer_relocation: 'Relocations',
    layer_ecology: 'Ecological memory',
    layer_place: 'Vanished places',
    basemap: 'Base map',
    basemap_hint: 'Aerial imagery shows the made ground and seawalls directly.',
    coastline: 'Historical coastline',
    coastline_hint: 'Pick a year to compare the shoreline before and after reclamation.',
    coastline_opacity: 'Opacity',
    coastline_swipe: 'Swipe compare',
    communities: 'Communities',
    search: 'Search',
    search_placeholder: 'Place, boat, person…',
    timeline_label: 'Period',
    reset: 'Reset',
    add_story: 'Add a story',
    export: 'Export data',

    c_tanka: 'Tanka 蜑家',
    c_sheungan: 'Boat dwellers 水上人',
    c_hoklo: 'Hoklo 鶴佬',
    c_hakka: 'Hakka 客家',
    c_punti: 'Land-based 陸上',
    c_other: 'Other',

    k_story: 'Story',
    k_relocation: 'Relocation',
    k_ecology: 'Ecology',
    k_place: 'Place',

    narrator: 'Narrator',
    recorded_by: 'Recorded by',
    period: 'Period',
    community: 'Community',
    moved_from: 'From',
    moved_to: 'To',
    distance: 'Distance',
    species_label: 'Species',
    ecology_change_label: 'Environmental change',
    source: 'Source',
    transcript: 'Transcript',
    listen: 'Listen',
    report: 'Report',
    share: 'Copy link',
    link_copied: 'Link copied',
    withheld_note: 'The narrator asked that the exact location not be published. This marker is approximate.',
    no_results: 'No records match these filters. Try widening the period or clearing community filters.',

    form_title: 'Record a story',
    form_lede: 'Everything you add appears on the map immediately. Please only share what is yours to share — if the story belongs to someone else, ask them first.',
    f_kind: 'What kind of record is this?',
    f_kind_story: 'A memory of a place',
    f_kind_relocation: 'A relocation (from sea to land)',
    f_kind_ecology: 'A change in fishing grounds, fish, or the sea',
    f_kind_place: 'A place that no longer exists',
    f_title_zh: 'Title (中文)',
    f_title_en: 'Title (English)',
    f_narrative_zh: 'The story (中文)',
    f_narrative_en: 'The story (English)',
    f_narrative_help: 'Either language is fine. This can be a transcript excerpt or a few sentences.',
    f_where: 'Where',
    f_pick_origin: 'Pick a point on the map',
    f_pick_dest: 'Pick where they moved to',
    f_place_name: 'Place name',
    f_dest_place_name: 'Destination name',
    f_no_point: 'No location chosen yet',
    f_precision: 'Location precision',
    p_exact: 'Exact',
    p_approximate: 'Approximate',
    p_area: 'General area',
    p_withheld: 'Withhold exact location',
    f_precision_help: 'Choosing "withhold" publishes the story but rounds the coordinates to roughly one kilometre.',
    f_when: 'When',
    f_year_start: 'From (year)',
    f_year_end: 'To (year)',
    f_year_help: 'Uncertainty is fine — fill in one, both, or neither.',
    f_communities: 'Communities involved',
    f_species: 'Fish / species',
    f_species_help: 'Use whatever names the narrator used, separated by commas.',
    f_ecology_change: 'What changed?',
    f_media: 'Audio and photographs',
    f_audio: 'Audio recording (max 50MB)',
    f_photos: 'Photographs',
    f_transcript_zh: 'Transcript (中文)',
    f_transcript_en: 'Transcript (English)',
    f_provenance: 'Provenance',
    f_narrator: 'How to name the narrator',
    f_narrator_help: 'A pseudonym or "Anonymous" is fine. Do not use a full name unless they explicitly agreed to it.',
    f_birth_year: 'Year of birth',
    f_contributor: 'Your name',
    f_contact: 'Your email',
    f_contact_help: 'Never published. Used only so the research team can reach you if needed.',
    f_source_note: 'Source note',
    f_source_help: 'e.g. Interview, March 2026; family album; 《香港漁民史》p.102.',
    consent_title: 'Consent',
    consent_1: 'I confirm this is mine to share. If it was told to me by someone else, they agreed to it being published.',
    consent_2: 'I agree to publish this under CC BY-SA 4.0, so others may reuse it with attribution.',
    submit: 'Publish to the map',
    submitting: 'Publishing…',
    cancel: 'Cancel',
    submit_ok: 'Published. Thank you for recording this.',
    err_title: 'Please give the story a title in at least one language.',
    err_point: 'Please pick a location on the map.',
    err_dest: 'A relocation needs a destination point.',
    err_consent: 'Please tick both consent boxes.',
    err_network: 'Could not publish. Please try again shortly.',
    err_rate: 'Too many submissions in a short time. Please wait a few minutes.',
    click_map_origin: 'Click the map where the story took place',
    click_map_dest: 'Click the map where they moved to',

    report_title: 'Report a problem',
    report_lede: 'This project publishes instantly. Your report goes to the research team; anything raising privacy or consent is hidden immediately.',
    r_spam: 'Spam',
    r_abuse: 'Hateful or abusive',
    r_privacy: 'Privacy violation',
    r_consent: 'Published without consent',
    r_inaccurate: 'Factually wrong',
    r_other: 'Other',
    r_detail: 'Anything else we should know',
    report_send: 'Send report',
    report_ok: 'Received. Thank you.',
  },
}

const STORAGE_KEY = 'tideline.locale'

/** Browser default, unless the visitor has chosen otherwise before. */
function detect() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (LOCALES.includes(saved)) return saved
  return navigator.language?.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

let current = detect()
const listeners = new Set()

export const locale = () => current

export function setLocale(next) {
  if (!LOCALES.includes(next) || next === current) return
  current = next
  localStorage.setItem(STORAGE_KEY, next)
  document.documentElement.lang = next === 'zh' ? 'zh-Hant-HK' : 'en'
  applyDom()
  listeners.forEach((fn) => fn(next))
}

export const onLocaleChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn) }

/** Translate. Falls back to the key itself so a missing string is visible in
    the UI rather than rendering as a silent blank. */
export function t(key) {
  return STRINGS[current][key] ?? STRINGS.en[key] ?? key
}

/** Pick the field for the current locale, falling back to the other language.
    Records are often written in one language only, and showing the Chinese to
    an English reader is far better than showing them nothing. */
export function pick(row, base) {
  const mine = row[`${base}_${current}`]
  if (mine) return mine
  const other = current === 'zh' ? row[`${base}_en`] : row[`${base}_zh`]
  return other || ''
}

/** Rewrite every [data-i18n] node in the document. */
export function applyDom(root = document) {
  root.querySelectorAll('[data-i18n]').forEach((el) => {
    el.textContent = t(el.dataset.i18n)
  })
  root.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
    el.placeholder = t(el.dataset.i18nPlaceholder)
  })
}

export const COMMUNITIES = [
  { id: 'tanka',    key: 'c_tanka' },
  { id: 'sheungan', key: 'c_sheungan' },
  { id: 'hoklo',    key: 'c_hoklo' },
  { id: 'hakka',    key: 'c_hakka' },
  { id: 'punti',    key: 'c_punti' },
  { id: 'other',    key: 'c_other' },
]
